export const OTHER_WRAP_CODE = 'Other' as const
export const ALREADY_SCHEDULED_WRAP_CODE = 'Hospital follow-up already scheduled' as const
export const PROVIDER_NOT_FOUND_WRAP_CODE = 'Provider not found' as const

export const WRAP_CODES = {
  no_appt_hospital: [
    'Clinic contacted and will contact patient',
    'Unable to contact employed clinic, formstack submitted',
    'Unable to contact external clinic, patient to schedule',
    PROVIDER_NOT_FOUND_WRAP_CODE,
    OTHER_WRAP_CODE,
  ],
  no_appt_pac: [
    'Patient did not answer phone',
    'Patient declined to schedule',
    'Clinic contacted and declined to schedule',
    'Unable to contact clinic; appointment request sent',
    'Submitted to TCM nurse for scheduling',
    PROVIDER_NOT_FOUND_WRAP_CODE,
    OTHER_WRAP_CODE,
  ],
  appt_hospital: [
    'Contacted clinic',
    OTHER_WRAP_CODE,
  ],
  appt_pac: [
    'Appointment found in Athena',
    'Contacted clinic',
    OTHER_WRAP_CODE,
  ],
} as const satisfies Record<string, readonly string[]>

export type WrapCodeContext = keyof typeof WRAP_CODES

export function getWrapCodeContext(
  scheduledOutside: boolean,
  isPac: boolean,
): WrapCodeContext {
  if (scheduledOutside) return isPac ? 'appt_pac' : 'appt_hospital'
  return isPac ? 'no_appt_pac' : 'no_appt_hospital'
}
